module.exports = __webpack_public_path__ + "img/DesktopVersionScheduleAppt.fbb8b76d.png";